import React, { useEffect, useRef } from 'react'

import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

import { Icon } from '@iconify/react'
import menu3Fill from '@iconify/icons-ri/menu-3-fill'

import useResponsive from '../hooks/useResponsive'
import CyanLogo from '../assets/svg/logo-cyan-omg.svg'
import MagentaLogo from '../assets/svg/logo-magenta-omg.svg'
import WhiteLogo from '../assets/svg/logo-white-omg.svg'
import NavMenu from './navmenu'
import NavSocial from './navsocial'

gsap.registerPlugin(ScrollToPlugin)

export default (props) => {

  const dropdown = useRef(null)
  const { isMobileMenu } = useResponsive()

  const toggleBurgerMenu = () => {
    dropdown.current.classList.toggle('is-active')
  }

  const anchorScrollTo = (toEl) => {
    gsap.to(window, {
      duration: 1,
      scrollTo: toEl,
    })

    if (dropdown.current?.classList.contains('is-active'))
      toggleBurgerMenu()
  }

  useEffect(() => {
    if (props.isLoaded) {
      gsap.to('.sideNav', {
        top: 0,
        left: 0,
        duration: .2,
      })
    }
  }, [props.isLoaded])

  return (
    <nav className="sideNav">
      <div className="sideNav__logo logo">
        <a className="logo__svgWrapper" title="Léo De Spiegeleer" href="https://leodsp.io">
          <CyanLogo className="logo__cyan" width={42} />
          <MagentaLogo className="logo__magenta" width={42} />
          <WhiteLogo className="logo__white" width={42} />
        </a>
      </div>

      {isMobileMenu &&
        <div ref={dropdown} className="dropdown menu__burger is-right">
          <div className="dropdown-trigger">
            <button onClick={() => toggleBurgerMenu()} className="menu__link is-link-button">
              <Icon icon={menu3Fill} width="32" />
              <div className="is-sr-only">Menu</div>
            </button>
          </div>        
          <div className="dropdown-menu" id="dropdown-menu">
            <div className="dropdown-content menu__dropdownContent">
              <NavMenu anchorScrollTo={anchorScrollTo} />
              <div className="divider menu__divider"></div>
              <NavSocial />
            </div>
          </div>
        </div>
      }

      {!isMobileMenu && <>
        <NavMenu anchorScrollTo={anchorScrollTo} />
        <NavSocial />
      </>}

    </nav>
  )
}
